import gql from 'graphql-tag'

export const GET_TRANSLATIONS = gql`
  query getTranslations($namespaces: [ID]!) {
    getTranslations(namespaces: $namespaces)
  }
`
